export default __webpack_public_path__ + "static/media/smurfette.90c33878.png";